import React from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import axios from "axios";

import {
  colHeaders,
  columns,
  colWidths,
  correctFields,
  compareNamesWithIds
} from "./data";
import { correctBoolean, generateData } from "../locations/data";

function handlerErrors(data) {
  Object.keys(data).forEach(key => {
    const nameErr = data[key].name === "";
    const locationErr = data[key].location_id === "";

    if (nameErr) {
      toastr.error("Name can't be blank.");
    }

    if (locationErr) {
      toastr.error("Location can't be blank.");
    }

    if (nameErr || locationErr) {
      delete data[key];
    }
  });

  return data;
}

class PoolEditor extends React.Component {
  state = {
    pools: correctFields(
      this.props.locations,
      this.props.pools.map(item => correctBoolean(item))
    )
  };

  render() {
    const { pools } = this.state;
    const { locations } = this.props;

    return (
      <div>
        <h1>Pools Editor</h1>
        <div className="row">
          <div className="col-md-12">
            <div className="pull-right">
              <a
                className="btn btn-pink btn-raised btn-long margin-right-five"
                href="/pools_importer"
              >
                IMPORT
              </a>
              <a
                className="btn btn-indigo btn-raised btn-long margin-right-five"
                onClick={this.onExport}
              >
                EXPORT
              </a>
            </div>
          </div>
        </div>
        <br />

        <HotTable
          data={pools}
          rowHeaders={false}
          colWidths={colWidths}
          colHeaders={colHeaders}
          columns={columns(locations)}
          width={1200}
          height={(pools.length * 25) + 80}
          onAfterChange={this.onAfterChange}
          fixedColumnsLeft={3}
        />
      </div>
    );
  }

  onAfterChange = (changesArray, source) => {
    if ((changesArray && source === "edit") || source === "CopyPaste.paste") {
      const tmpData = compareNamesWithIds(
        Object.assign({}, changesArray),
        this.props.locations
      );
      const data = handlerErrors(generateData(this.state.pools, tmpData));

      if (Object.keys(data).length === 0) {
        return;
      }

      axios.put("/pools_editor/mass_update", { pools: data }).then(resp => {
        toastr.success(resp.data.message);
      });
    }
  };

  onExport = () => {
    axios
      .post("/pools/export")
      .then(() => {
        toastr.success('Your Pool Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.');
      })
      .catch(() => {
        toastr.error("Unable to export Pools at this time.");
      });
  };
}

PoolEditor.propTypes = {
  locations: PropTypes.array,
  pools: PropTypes.array
};

export default PoolEditor;
